import React from 'react';
export var RouteContext = /*#__PURE__*/React.createContext(undefined);
export function useRouteData() {
  return React.useContext(RouteContext);
}